// index.tsx
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { NavigationPanel } from '@ncr-design-system/pattern-sidebar-navigation'
import React from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import SidebarTopItem from '../SidebarTopItem'
import SidebarBottomItem from '../sidebarBottomItem'
import { RootState } from '../../../redux'
import { linkComponent } from '../link-component'
import { sidebarRoutes } from '../sidebarRoutes'

function mapStateToProps(state: RootState) {
  return {
    user: state.user
  }
}

type SideBarProps = ReturnType<typeof mapStateToProps>

export function SideBar(
  {
    user
  }: Readonly<SideBarProps>
): JSX.Element {
  const { pathname } = useLocation()
  const userRole = {
    isLoggedIn: user.isLoggedIn,
    isAdmin: user.isAdmin
  }

  return (
    <NavigationPanel
      userRole={userRole}
      currentUrl={pathname}
      linkComponent={linkComponent}
      items={sidebarRoutes}
      components={{
        topItem: <SidebarTopItem />,
        bottomItems: <SidebarBottomItem />
      }}
      sx={{
        bgcolor: '#FFFFFF'
      }}
    />
  )
}

export default connect(mapStateToProps)(SideBar)
